import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import { MenuGroup, MenuGroupItem, Heading, MenuItem, MenuBox } from "./styels";
import { GetIcon } from "../../../../icons";
import PopupView from "../../../elements/popupview";
import Switch from "../../../router/switch";
import { useDispatch, useSelector } from "react-redux";
import { clearLogin } from "../../../../store/actions/login";
import AutoForm from "../../../elements/form";
import i18n from "i18next"; // i18n library for internationalization
import { getData, postData, putData } from "../../../../backend/api";
import { Title } from "../../common/layout/header/styels";
import { RowContainer } from "../../../styles/containers/styles";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../elements/checkbox";
import OnOffToggle from "../../../elements/toggle";
import FormInput from "../../../elements/input";
import { Footer, Form } from "../../../elements/form/styles";
const Settings = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${t("settings")} - Whistleblowing24`;
  }, [t]);
  const [company, setCompany] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [openData, setOpenData] = useState(null);
  const themeColors = useSelector((state) => state.themeColors);
  const selectedMenu = useSelector((state) => state.selectedMenu);
  const [selectedLanguage, setSelectedLanguage] = useState(
    // If a language is stored in local storage, use it, otherwise use "de"
    sessionStorage.getItem("_lang") !== null ? sessionStorage.getItem("_lang") : "de"
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLanguageChange = (language) => {
    // Change the language in the i18n library
    if (selectedLanguage === "en") {
      i18n.changeLanguage("de");
      setSelectedLanguage("de");
      sessionStorage.setItem("_lang", "de");
    } else {
      i18n.changeLanguage("en");
      setSelectedLanguage("en");
      sessionStorage.setItem("_lang", "en");
    }
  };
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showChangeDeadline, setShowChangeDeadline] = useState(false);
  const isCreatingHandler = (value, callback) => {
    setShowResetPassword(false);
  };
  const submitChange = async (post) => {
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...post }, "user/reset-password", dispatch, navigate)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t(response.data.message),
            okay: "Okay",
            onClose: () => {},
            code: 200
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 500 });
          props.setLoaderBox(false);
        }
        setShowResetPassword(false);
        props.setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        props.setLoaderBox(false);
      });
  };
  const formInput = [
    {
      type: "password",
      placeholder: "currentPassword",
      name: "currentPassword",
      validation: "",
      default: "",
      label: "currentPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
    {
      type: "password",
      placeholder: "newPassword",
      name: "newPassword",
      validation: "passwordMatch",
      default: "",
      label: "newPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
    {
      type: "password",
      placeholder: "confirmPassword",
      name: "confirmPassword",
      validation: "passwordMatch",
      default: "",
      label: "confirmPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
  ];

  const [toggle, setToggle] = useState(sessionStorage.getItem("user") !== null ? JSON.parse(sessionStorage.getItem("user"))?.user?.isAktWhistle : false);

  const handleToggle = async() => {
    try {
      await getData({ }, "whistleblowing/active", dispatch, navigate)
      .then((response) => {
        setToggle(response.data.whistleblowing);
        sessionStorage.setItem("user", JSON.stringify({ ...JSON.parse(sessionStorage.getItem("user")), user: { ...JSON.parse(sessionStorage.getItem("user")).user, isAktWhistle: response.data.whistleblowing } }));
      })
      .catch((error) => {
        console.log(error);
        });
    } catch (error) {
      console.error("Error toggling whistle settings:", error);
      
    }

  }

  // Case Deadlines function
  // useEffect(() => {
  //     getCaseDeadlines();
  //   }, []);
  
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [submitDisabled, setSubmitDisabled] = useState(true);
  
    const formInputDeadline = [
      {
        type: "number",
        placeholder: "autoOpenDaysPlaceholder",
        name: "autoOpenDays",
        validation: "",
        default: "",
        label: "autoOpenDays",
        required: true,
        customClass: "full",
        textWrap: "textWrap"
      },
      {
        type: "number",
        placeholder: "autoOpenDaysPlaceholder",
        name: "autoCloseDays",
        validation: "",
        default: "",
        label: "autoCloseDays",
        required: true,
        customClass: "full",
        textWrap: "textWrap"
      },
      
    ];
  
    // const getCaseDeadlines = async () => {
    //   try {
    //       props.setLoaderBox(true);
    //       const response = await getData({}, `company/admin?id=${props.user.user.company}`, dispatch, navigate);
    //       if(response.status === 200){
    //           props.setLoaderBox(false);
    //           setCompany(response?.data);
    //           setFormValues({autoOpenDays: response?.data?.autoOpenDays??"" , autoCloseDays: response?.data?.autoCloseDays??""});
    //           setFormErrors({autoOpenDays: "" , autoCloseDays: ""});
    //       }
    //   } catch (error) {
    //       console.error("error", error);
    //   }
    // }
  
    const validation = (fields, udpatedValue, formErrors, captchaStatus, useCaptcha, agreement, useCheckbox) => {
      const tempformErrors = { ...formErrors };
      let flags = 0;
      fields.forEach((item) => {
        if (item.name !== "_id") {
          if (item.type === "multiple") {
            item.forms.forEach((form, multipleIndex) => {
              form.forEach((inputs, index) => {
                const res = fieldValidation(inputs, typeof udpatedValue[item.name][multipleIndex][inputs.name] === "undefined" ? "" : udpatedValue[item.name][multipleIndex][inputs.name], udpatedValue);
                tempformErrors[item.name][multipleIndex][inputs.name] = res.tempformError;
                flags += res.flag; //?res.flag:0;
              });
            });
          } else {
            const res = fieldValidation(item, typeof udpatedValue[item.name] === "undefined" ? "" : udpatedValue[item.name], udpatedValue);
            tempformErrors[item.name] = res.tempformError;
            flags += res.flag; //?res.flag:0;
          }
        }
      });
  
      setFormErrors(tempformErrors);
      setSubmitDisabled(flags > 0 ? true : false);
      if (flags === 0) {
        return true;
      } else {
        return false;
      }
    };
  
    const fieldValidation = (field, value, udpatedValue) => {
      let flag = 0;
      let tempformError = "";
  
      if (!field.update && props.formType === "put") {
        return { flag, tempformError };
      }
      if (!field.required && value.length === 0) {
        return { flag, tempformError };
      }
      if (field.condition) {
        if (udpatedValue[field.condition.item] === field.condition.if) {
          if (field.condition.then === "disabled") {
            return { flag, tempformError };
          }
        } else {
          if (field.condition.else === "disabled") {
            return { flag, tempformError };
          }
        }
      }
      switch (field.validation) {
        case "email":
          const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
          if (!regex.test(value)) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
          break;
        case "passwordMatch":
          const validatePassword = (password) => {
            if (!password) return false;
            if (password.length < 6) return false;
            if (password.length > 15) return false;
            
            let upper = 0;
            let lower = 0;
            let number = 0;
            let special = 0;
            
            for (let i = 0; i < password.length; i++) {
              const char = password[i];
              if (/[0-9]/.test(char)) number++;
              else if (char.toUpperCase() !== char.toLowerCase()) {
                if (char === char.toUpperCase()) upper++;
                else lower++;
              }
              else special++;
            }
            
            if (upper < 1 || lower < 1 || number < 1 || special < 1) return false;
            
            return true;
          };

          if (field.name === "newPassword" || field.name === "password") {
            if (!validatePassword(value)) {
              tempformError = t("passwordCriteria");
              flag += 1;
              break;
            }
          }

          if (udpatedValue["newPassword"] !== udpatedValue["confirmPassword"]) {
            tempformError = t("passwordEqual");
            flag += 1;
          }
          break;
        case "fileNumber":
          const fileNumber = /[A-Z0-9-]/;
          if (!fileNumber.test(value)) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
          break;
        case "licensePlate":
          const german = /^[A-Z]{3}[ -]?[A-Z0-9]{2}[ -]?[A-Z0-9]{3,6}$/i;
          if (!german.test(value)) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
          break;
  
        case "amount":
          const amount = /^\d+([.,]\d{1,2})?$/;
          if (!amount.test(value)) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
          break;
        case "datetime":
        case "time":
          const date = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/;
          if (!date.test(value)) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
          break;
        case "text":
          break;
        default:
          break;
      }
      if (field.type === "date" || field.type === "datetime") {
        if (field.greater) {
          const fieldValue = new Date(udpatedValue[field.greater]);
          const currentValue = new Date(value);
  
          // // Set time of date to 00:00
          // fieldValue.setHours(0, 0, 0, 0);
          // currentValue.setHours(0, 0, 0, 0);
  
          // const differenceInTime = currentValue.getTime() - fieldValue.getTime();
          // const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
  
          // if (differenceInDays < 1) {
          //   tempformError = t("validContent", { label: t(field.label) });
          //   flag += 1;
          // }
          if (fieldValue > currentValue) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
        }
  
        if (field.less) {
          const fieldValue = new Date(udpatedValue[field.less]);
          const currentValue = new Date(value);
          // const differenceInDays = Math.floor((fieldValue - currentValue) / (1000 * 60 * 60 * 24));
          // if (differenceInDays <= 1) {
          //   tempformError = t("validContent", { label: t(field.label) });
          //   flag += 1;
          // }
          if (fieldValue < currentValue) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
        }
      }
      if (field.type === "image" || field.type === "file") {
        if (value.length === 0) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
      } else {
        if (field.required && value?.length === 0) {
          tempformError = t("required", { label: t(field.label) });
          flag += 1;
        } else if (field.minimum > value?.length) {
          tempformError = t("requiredMinimum", { minimum: field.minimum, label: t(field.label) });
  
          flag += 1;
        } else if (field.maximum < value?.length) {
          tempformError = t("maxLimit", { maximum: field.maximum, label: t(field.label) });
  
          flag += 1;
        }
      }
  
      return { flag, tempformError };
    };
  
    const handleChangeDeadline = (index, event, id) => {
      const field = formInputDeadline[id];
      const value = event.target.value;
      const values = { ...formValues,[field.name]: value }
      setFormValues(values);
      const valid = validation(formInputDeadline, values, formErrors, false, false, false, false);
    }
    
    const submitChangeDeadline = async(event) => {
      event.preventDefault();
      
      if (validation(formInputDeadline, formValues, formErrors, false, false, false, false)) {
         try {
          props.setLoaderBox(true);
              await putData({ ...formValues }, `company/admin/${props.user.user.company}`, dispatch, navigate)
                .then((response) => {
                  if (response.status === 200) {
                    props.setMessage({
                      type: 1,
                      content: t("caseDeadlinesUpdated"),
                      okay: "Okay",
                      onClose: () => {},
                      code: 200
                    });
                    props.setLoaderBox(false);
                  } else if (response.status === 201) {
                    props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 201 });
                    props.setLoaderBox(false);
                  } else {
                    props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 500 });
                    props.setLoaderBox(false);
                  }
                  props.setLoaderBox(false);
                })
                .catch((error) => {
                  props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
                  props.setLoaderBox(false);
                });
         } catch (error) {
           console.error("error while submitting the form", error);
         }
      }
    };

  return (
    <RowContainer className="list static">
      <Title className="inner">
        <GetIcon icon={"settings"}></GetIcon>
        {t("settings")}
      </Title>
      <MenuGroup>
        {props.router.groups.map((item) => (
          <MenuGroupItem key={item.head}>
            <Heading>{t(item.head)}</Heading>
            <MenuBox>
              {item.menuItems.map((menu) => (
                <MenuItem
                  key={menu.label}
                  onClick={() => {
                    if (menu.label === "logout") {
                      dispatch(clearLogin());
                    } else if (menu.label === "languageSwitch") {
                      handleLanguageChange();
                    } else if (menu.label === "resetPassword") {
                      setShowResetPassword(true);
                    } else if (menu.label === "caseDeadlines") {
                      setShowChangeDeadline(true);
                    } else if (menu.label === "whistleblowing") {
                      // handleToggle();
                    } else {
                      setOpenData({ data: { name: menu.label } });
                      setSelectedMenuItem(menu);
                      setShowDetails(true);
                    }
                  }}
                >
                  <GetIcon icon={menu.icon}></GetIcon>
                  {t(menu.label)}
                  {menu.checkbox && (
                    <div style={{ marginLeft: "auto" }}>
                      <OnOffToggle on={toggle} handleToggle={handleToggle} page="whistle-settings" />
                    </div>
                  )}
                </MenuItem>
              ))}
            </MenuBox>
          </MenuGroupItem>
        ))}
      </MenuGroup>
      {showDetails && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={selectedMenuItem && <Switch page={selectedMenuItem.element} />}
          themeColors={themeColors}
          closeModal={() => {
            setShowDetails(false);
            setSelectedMenuItem(null);
          }}
          setMessage={props.setMessage}
          setLoaderBox={props.setLoaderBox}
          itemTitle={{ collection: "", name: "name" }}
          openData={openData} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={"fullpage nopadding"}
          menu={selectedMenu}
        ></PopupView>
      )}
      {showResetPassword && <AutoForm formMode={"single"} enterSubmit={true} useCaptcha={false} formType={"post"} header={t("resetPassword")} formInput={formInput} submitHandler={submitChange} button={t("confirm")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={false}></AutoForm>}
      {showChangeDeadline && <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={<><Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
            action="#"
            method="POST"
            className={`${props.login??""} ${props.plainForm ? "plain" : "popup"} `}
          >
            {/* Looping the form input array for generating the dynamic form*/}
            {formInputDeadline &&
              formInputDeadline.map((item, index) => {
                let dynamicClass = "";
                if (item.condition) {
                  if (formValues[item.condition.item] === item.condition.if) {
                    dynamicClass = item.condition.then;
                  } else {
                    dynamicClass = item.condition.else;
                  }
                }
                return (
                    <FormInput index={0} animation={`sub-1`} placeholder={item.placeholder} key={`input` + index} id={index} formValues={formValues} error={formErrors[formInputDeadline[index].name]} value={formValues[formInputDeadline[index].name]} {...item} onChange={handleChangeDeadline} />
                  )
              })}

              {/* <div style={{ display: "none" }}>
                <FormInput disabled={submitDisabled} type="submit" name="submit" value={t(props.button ? props.button : "submit")} onChange={submitChange} login={props.login} />
              </div> */}
        </Form>
        <Footer className={`center`}>
            <FormInput type="close" value={t("cancel")} onChange={()=> setShowChangeDeadline(false)} />
            <FormInput disabled={submitDisabled} type="submit" name="submit" value={t(props.button ? props.button : "submit")} onChange={submitChangeDeadline} />
        </Footer>
      </>}
          themeColors={themeColors}
          closeModal={() => {
            setShowChangeDeadline(false);
          }}
          setMessage={props.setMessage}
          setLoaderBox={props.setLoaderBox}
          itemTitle={"caseDeadlines"}
          openData={openData} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={""}
          menu={selectedMenu}
        ></PopupView>
        }
    </RowContainer>
  );
};
// exporting the page with parent container layout..
export default Layout(Settings);
